import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { ServiceThreadSpinner } from '.';
import { api } from '../utils';

export default function ManageConfig() {
   const [hours, setHours] = useState(0);
   const [spin, setSpinner] = useState(true);

   useEffect(() => {
      GetShiftHours();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function GetShiftHours() {
      setSpinner(true);
      api
         .fetch(`Reference/GetShiftHours`)
         .then((response) => {
            if (response.data.success) {
               setHours(response.data.hours);
            } else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   function onShiftHourChange(val) {
      setHours(val);
      SetShiftHours(val);
   }

   function SetShiftHours(val) {
      setSpinner(true);
      api.post(`Reference/SetShiftHours/${val}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Shift updated!")
            } else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinner(false);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spin}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6 width95px">
                                       Choose an option below to set the hours per shift.
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="110px">
                                       Shift Hours:
                                    </td>
                                    <td className="transparent-background">
                                       <Input
                                          type="radio"
                                          name="shiftOption"
                                          checked={hours === 8}
                                          onChange={() => onShiftHourChange(8)} className="me-1" />8 hours
                                       <Input
                                          type="radio"
                                          name="shiftOption"
                                          checked={hours === 12}
                                          onChange={() => onShiftHourChange(12)} className="ms-4 me-1" />12 hours
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
